import { render, staticRenderFns } from "./peiYu.vue?vue&type=template&id=e2a2caca&scoped=true&"
import script from "./peiYu.vue?vue&type=script&lang=js&"
export * from "./peiYu.vue?vue&type=script&lang=js&"
import style0 from "./peiYu.vue?vue&type=style&index=0&id=e2a2caca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a2caca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2025/DiTuYouXuan/DiTuAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2a2caca')) {
      api.createRecord('e2a2caca', component.options)
    } else {
      api.reload('e2a2caca', component.options)
    }
    module.hot.accept("./peiYu.vue?vue&type=template&id=e2a2caca&scoped=true&", function () {
      api.rerender('e2a2caca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sysconfig/systemCreator/systemConfig/bonusConfig/bounsCond/peiYu.vue"
export default component.exports